import { mdiCheck } from '@mdi/js';
import { Icon } from '@mdi/react';
import { Button, TextField } from '@mollybet/ui';
import { useTheme } from '@mollybet/ui/dist/styled';
import { useProducerWithThunks } from 'common/hooks/useProducer';
import { recoverRecipe } from 'common/state/auth/recipes';
import { defaultRecoverState } from 'common/state/auth/states';
import { doRecover } from 'common/state/auth/thunkActions';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const RecoverFormElement = styled.form`
  display: grid;
  grid-template-rows: auto auto auto auto;
  justify-items: center;
  align-items: center;
`;

const BackLink = styled(Link)`
  color: inherit;
  text-decoration: none;
  cursor: pointer;
  width: fit-content;
  padding-bottom: 0.125rem;
  border-bottom: 1px dashed;
  font-size: 0.875rem;
  margin-right: 0.5rem;
  opacity: 0.5;
  transition: opacity 300ms;
  margin-top: 1.25rem;

  &:hover {
    opacity: 1;
  }
`;

const SubmitButton = styled(Button)`
  width: 100%;
  margin-top: 0.75rem;
`;

const Info = styled.p`
  max-width: 300px;
`;

const ErrorMessage = styled.div`
  color: ${({ theme }) => theme.danger};
  margin-bottom: 1rem;
  max-width: 300px;
`;

const SuccessMessage = styled.div`
  height: 5.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;

  svg {
    margin-right: 1rem;
  }
`;

export const RecoverForm = () => {
  const theme = useTheme();
  const [username_or_email, setRecoveryAccount] = useState('');
  const [recoverState, dispatch] = useProducerWithThunks(
    recoverRecipe,
    defaultRecoverState
  );

  const submitRecover = (event: React.FormEvent) => {
    event.preventDefault();
    dispatch(doRecover(username_or_email));
  };

  return (
    <RecoverFormElement onSubmit={submitRecover}>
      <Info>
        If you have forgotten your password, please enter the username or e-mail
        you are using to log into Totus. We will send a reset link to the e-mail
        we have on record.{' '}
      </Info>
      {recoverState.error && (
        <ErrorMessage>
          {recoverState.error.split(':').slice(-1)[0]}
        </ErrorMessage>
      )}

      {recoverState.outcome === 'Success' ? (
        <SuccessMessage>
          <Icon path={mdiCheck} size={1} color={theme.primary} />
          <span>Recovery request sent.</span>
        </SuccessMessage>
      ) : (
        <>
          <TextField
            style={{ width: 300 }}
            label="Username or Email Address"
            value={username_or_email}
            onChange={(e) => setRecoveryAccount(e.target.value)}
          />
          <SubmitButton
            type="submit"
            variant="primary"
            disabled={!username_or_email}
          >
            Send
          </SubmitButton>
        </>
      )}
      <BackLink to="/login">Back to login.</BackLink>
    </RecoverFormElement>
  );
};
